<template>
    <modal
        name="visibilidad-reducida"
        transition="pop-out"
        :width="800"
        height="auto"
        scrollable
        id="visibilidad-reducida"
        :adaptive="true"
        :click-to-close="false"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2 class="text-dark">Sector con visibilidad reducida</h2>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <h3 class="text-danger">Este sector es de visibilidad reducida, no garantizamos la perfecta visión del evento.</h3>
                <div v-if="zona?.texto_visibilidad_reducida" v-html="zona.texto_visibilidad_reducida"></div>
            </div>
            <div class="card-footer text-right">
                <slot name="footer">
                    <Button type="button" name="button" @click.prevent="aceptar()">Aceptar</Button>
                </slot>
            </div>
        </div>
    </modal>
</template>


<script>
    export default {
        props: {
            zona: {
                type: Object
            }
        },
        methods: {
            aceptar(){
                this.$emit('aceptar');
            },
        },
    }
</script>